import { accountQueryKey } from 'api-validations/user-api'
import { type ApiClient, useApiClient, useMutation, useQueryClient } from 'shared-ui/api-provider'
import type { ApiError } from 'utils'

type Params = {
  username: string
}

const mutationFn =
  (client: ApiClient) =>
  ({ username }: Params) => {
    return client.put(`/useraccounts/${username}/accepteula`).then((res) => res.status)
  }

type Response = Awaited<ReturnType<ReturnType<typeof mutationFn>>>

export const useAcceptEula = () => {
  const apiClient = useApiClient()
  const queryClient = useQueryClient()

  return useMutation<Response, ApiError, Params>({
    mutationFn: mutationFn(apiClient),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [accountQueryKey] })
    }
  })
}
